export const toggleMutator = async (state, payload) => {
  state.toggleState = payload
}

export const recordMutator = async (state, payload) => {
  state.recordState = payload
}
